import styled, { css } from 'styled-components';
import { forIE, forDesktop } from '@westwing/ui-kit/breakPoints';
import { header6 } from '@westwing/ui-kit/typography';
import scroll from '../../GlobalStyles/scroll';

export const SearchWrapper = styled.div<{ isSearchOverlayActive: boolean; hideOnMobile: boolean }>`
    grid-area: search;
    position: relative;
    margin: 0 0 0 14px;
    display: ${({ hideOnMobile }) => (hideOnMobile ? 'none' : 'flex')};
    flex-flow: column;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.white};
    z-index: ${({ theme }) => theme.zIndexContentOverlay};

    ${forIE`
        display: flex;
        -ms-grid-row: 2;
        -ms-grid-row-span: 1;
        -ms-grid-column: 5;
        -ms-grid-column-span: 3;
    `}

    /* styles to apply when the search is active in mobile */
    ${({ isSearchOverlayActive }) =>
        isSearchOverlayActive
            ? css`
                  position: fixed;
                  width: 100vw;
                  justify-content: flex-start;
                  margin: 0;
                  top: 0;
                  background: ${({ theme }) => theme.colors.white};
                  height: 100vh;
              `
            : ''}

    ${forDesktop`
        display: flex;
        top: 0;
        margin: 36px 14px;
        align-items: flex-end;
        z-index: ${({ theme }) => theme.zIndexContentOverlay + 1};
    `}

    ${({ isSearchOverlayActive }) =>
        isSearchOverlayActive
            ? forDesktop`
                  position: relative;
                  width: auto;
                  justify-content: center;
                  margin: 36px 14px;
                  height:  auto;
              `
            : ''}
`;

export const SearchHeader = styled.header<{ isSearchOverlayActive: boolean }>`
    display: none;
    grid-template: '. text icon .' 62px / 30px 1fr 15px 15px;
    align-items: center;
    width: 100%;
    padding: 0 5px;

    ${({ isSearchOverlayActive }) =>
        isSearchOverlayActive
            ? css`
                  display: grid;
              `
            : ''}

    ${forDesktop`
        display: none;
    `}
`;

export const SearchText = styled.span`
    ${header6}
    text-align: center;
    grid-area: text;
    color: ${({ theme }) => theme.colors.charcoal100};
`;

export const SearchContainer = styled.div<{ isSearchOverlayActive: boolean }>`
    flex-grow: 1;
    width: 100%;
    height: calc(100vh - 114px);
    display: none;
    overflow: auto;
    ${({ isSearchOverlayActive }) =>
        isSearchOverlayActive
            ? css`
                  display: block;
                  ${scroll('y')}
              `
            : ''}

    ${forDesktop`
        position: absolute;
        top: 10px;
        height: auto;
        overflow: hidden;
    `}
`;

export const SearchContainerWrapper = styled.div`
    position: relative;
    width: 100%;
    margin: 0 auto;
    ${forDesktop`
        max-width: 400px;
    `}
`;

export const CloseButton = styled.button`
    grid-area: icon;
`;
